import service from "./service";

async function getTaskDetail(payload) {
  try {
    const res = await service.getTaskDetail(payload);
    return res;
  } catch (error) {
    return null;
  }
}

async function getTasks(payload) {
  try {
    const res = await service.getTasks(payload);
    return res;
  } catch (error) {
    console.error("작업 목록 조회 중 오류 발생:", error);
    return null;
  }
}

/**
 * getTasksEdit
 * @property {number} id
 */
async function getTasksEdit(payload) {
  try {
    const res = await service.getTasksEdit(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getTasksMembers
 * @property {number} id
 */
async function getTasksMembers(payload) {
  try {
    const res = await service.getTasksMembers(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getTasksTimes
 * @property {number} id
 */
async function getTasksTimes(payload) {
  try {
    const res = await service.getTasksTimes(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getProjectsName
 * @property {number} id
 */
async function getProjectsName(payload) {
  try {
    const res = await service.getProjectsName(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * deleteTasks
 * @property {number} payload.id
 */
async function deleteTasks(payload) {
  try {
    const res = await service.deleteTasks(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * createTask
 * @typedef {object} payload
 * @property {number} datasetId 데이터셋 id
 * @property {number} interfaceId 인터페이스 id
 * @property {string} manualUrl 매뉴얼
 * @property {string} name 작업이름
 * @property {number} projectId 프로젝트 id
 * @property {number} setId 세트 id
 * @property {object} testConfig 테스트
 * @property {array} workTimeConfig 파일 할당 유지 시간/최소 작업, 검수 시간
 * @property {object} workerConfig 담당자
 */
async function createTask(payload) {
  try {
    const res = await service.createTask(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * updateTask
 * @param {Object} payload
 */
async function updateTask(payload) {
  try {
    const res = await service.updateTask(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getTaskProjects
 */
async function getTaskProjects() {
  try {
    const res = await service.getTaskProjects();
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getTaskInterfaces
 */
async function getTaskInterfaces() {
  try {
    const res = await service.getTaskInterfaces();
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * 프로젝트 결과 생성
 * createProejctResult
 */
async function createProejctResult(payload) {
  try {
    const res = await service.createProejctResult(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * 작업 결과 생성
 * createTaskResult
 */
async function createTaskResult(payload) {
  try {
    const res = await service.createTaskResult(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getTaskRoles
 * @param {number} payload.taskId
 */
async function getTaskRoles(payload) {
  try {
    const res = await service.getTaskRoles(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getCandidates
 * @param {number} payload.datasetId required
 * @param {number} payload.limit
 * @param {string} payload.order
 * @param {number} payload.page
 * @param {number} payload.setId required
 * @param {string} payload.sort
 */
async function getCandidates(payload) {
  try {
    const res = await service.getCandidates(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * updateCandidates
 * @param {binary} payload.csv required
 * @param {string} payload.datasetId required
 * @param {number} payload.setId required
 * @param {string} payload.type required
 */
async function updateCandidates(payload) {
  try {
    const res = await service.updateCandidates(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * setCandidates
 * @param {number} payload.datasetId required
 * @param {number} payload.setId required
 */
async function setCandidates(payload) {
  try {
    const res = await service.setCandidates(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * downloadCandidatesCSV
 * @param {number} payload.datasetId required
 * @param {number} payload.setId required
 * @param {string} payload.type required
 */
async function downloadCandidatesCSV(payload) {
  try {
    const res = await service.downloadCandidatesCSV(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * getCandidatesCount
 * @param {number} payload.datasetId
 * @param {number} payload.setId
 */
async function getCandidatesCount(payload) {
  try {
    const res = await service.getCandidatesCount(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * resetCandidates
 * @param {number} payload.datasetId
 * @param {number} payload.setId
 * @param {number} payload.taskId
 */
async function resetCandidates(payload) {
  try {
    const res = await service.resetCandidates(payload);
    return res;
  } catch (error) {
    return null;
  }
}

/**
 * deleteCandidates
 * @param {number} payload.datasetId
 * @param {number} payload.setId
 */
async function deleteCandidates(payload) {
  try {
    const res = await service.deleteCandidates(payload);
    return res;
  } catch (error) {
    return null;
  }
}

export default {
  getTaskDetail,
  getTasks,
  getTasksEdit,
  getTasksMembers,
  getTasksTimes,
  getProjectsName,
  deleteTasks,
  createTask,
  updateTask,
  getTaskProjects,
  getTaskInterfaces,
  createProejctResult,
  createTaskResult,
  getTaskRoles,
  getCandidates,
  updateCandidates,
  setCandidates,
  downloadCandidatesCSV,
  getCandidatesCount,
  resetCandidates,
  deleteCandidates,
};
